import {Component, Input, ElementRef} from '@angular/core';
import {FieldMessageI} from './field.message.i';

@Component({selector: 'message', template: '<ng-content></ng-content>'})
export class FieldMessage implements FieldMessageI {

    @Input('type') public messageType: string;

    constructor(private element: ElementRef) {
    }

    private isOpen: boolean;

    public getOpen() {
        return this.isOpen;
    }

    public setOpen(isOpen: boolean) {
        this.isOpen = isOpen;
        this.element.nativeElement.style.display = isOpen ? 'block' : 'none';
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/validation/field.message.ts